import React from 'react';
import { Box, Typography, keyframes } from '@mui/material'; // Add keyframes
import palette from '../../theme/palette';
import Iconify from '../Iconify';
import { useSelector } from '../../redux/store';
import useResponsive from '../../hooks/useResponsive';
import useLocales from '../../hooks/useLocales';

// 1. Define the animation
const marqueeAnimation = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
`;

export const Announcement = () => {
  const { translate } = useLocales();
  const isDesktop = useResponsive('up', 'lg');
  const { siteSettings } = useSelector((x) => x.lookup);
  const content = siteSettings?.announcement_text?.WalkPromotion?.content;

  const displayText = content || translate('no_announcement_for_moment');

  return (
    <>
      {isDesktop && (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Box sx={{ width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                paddingY: '6px',
                px: 2,
                overflow: 'hidden',
                backgroundColor: '#727374',
              }}
            >
              <Iconify
                icon={'pepicons-pencil:megaphone'}
                color={palette.home.announcement.color}
                width={20}
                height={20}
                sx={{ mr: 1, flexShrink: 0, zIndex: 2 }}
              />

              <Box
                sx={{
                  flexGrow: 1,
                  overflow: 'hidden',
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  height: '24px',
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontWeight: 500,
                    fontSize: { xs: '0.75rem', md: '0.875rem' },
                    whiteSpace: 'nowrap',
                    position: 'absolute',
                    animation: `${marqueeAnimation} 30s linear infinite`,
                  }}
                >
                  {displayText}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {!isDesktop && (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Box sx={{ width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                paddingY: '6px',
                px: 2,
                overflow: 'hidden',
                borderRadius: 1,
                backgroundColor: '#282a31',
              }}
            >
              <Iconify
                icon={'pepicons-pencil:megaphone'}
                color={palette.home.announcement.color}
                width={20}
                height={20}
                sx={{ mr: 1, flexShrink: 0, zIndex: 2 }}
              />

              <Box
                sx={{
                  flexGrow: 1,
                  overflow: 'hidden',
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  height: '24px',
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontWeight: 500,
                    fontSize: { xs: '0.75rem', md: '0.875rem' },
                    whiteSpace: 'nowrap',
                    position: 'absolute',
                    animation: `${marqueeAnimation} 30s linear infinite`,
                  }}
                >
                  {displayText}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
